"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpiredTimeout = void 0;
const features_1 = require("../../features");
const tracker_1 = require("../../tracker");
const translations_1 = require("../../translations");
const useExpiredTimeout = (props) => {
    return (0, features_1.useExpiredTimeout)({ ...props, tracker: tracker_1.tracker, translate: translations_1.translate });
};
exports.useExpiredTimeout = useExpiredTimeout;
//# sourceMappingURL=useExpiredTimeout.js.map